import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	FormControl, FormGroup, ControlLabel, Button,
} from 'react-bootstrap';
import { Select } from '@components/common';

class DeclineEstimate extends PureComponent {
	constructor(props) {
		super(props);
		this.dropdownOptions = [
			{ label : 'Estimate needs to be revised', value : 0, description : 'The estimate needs to be revised.' },
			{ label : 'Need to close job', value : 1, description : 'This job needs to be closed.' },
			{ label : 'Other...', value : 2, description : '' },
		];

		this.state = {
			reasonPreset : -1,
		};
	}

	changeReason = ({ description, value : reasonPreset }) => {
		const { onChange } = this.props;
		this.setState({ reasonPreset });

		onChange(null, description);
	}

	render() {
		const {
			reason, reasonValidation, onChange, declineEstimate,
		} = this.props;

		const { reasonPreset } = this.state;

		return (
			<Fragment>
				<div className="font-size-16 font-semi-bold">Reason for declining an estimate</div>
				<hr />
				<div className="margin-bottom-15">We will let the client know the reason why you have chosen to deny the approval</div>
				<FormGroup validationState={reasonValidation}>
					<Select
						placeholder="Select a Reason"
						onChange={this.changeReason}
						options={this.dropdownOptions}
						value={reasonPreset}
						className="margin-bottom-10"
					/>
					<ControlLabel>Add Note:</ControlLabel>
					<FormControl
						type="text"
						componentClass="textarea"
						rows={8}
						value={reason}
						onChange={onChange}
					/>
				</FormGroup>
				<Button
					type="button"
					id="decline-button"
					onClick={() => declineEstimate()}
					bsStyle="primary"
				>
					Decline Estimate
				</Button>
			</Fragment>
		);
	}
}

DeclineEstimate.propTypes = {
	reason           : PropTypes.string,
	reasonValidation : PropTypes.string,
	onChange         : PropTypes.func.isRequired,
	declineEstimate  : PropTypes.func.isRequired,
};

DeclineEstimate.defaultProps = {
	reason           : '',
	reasonValidation : null,
};

export default DeclineEstimate;
